











import { useIsInViewport } from '@superbet-group/web.lib.vue-utilities';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
    name: 'InfiniteScroller',
    props: {
        /**
         * The offset in pixels from the bottom of the viewport at which the `bottomReached` event will be emitted.
         */
        offsetY: {
            type: Number,
            required: false,
            default: 600,
        },
    },
    emits: ['bottomReached'],
    setup(_props, { emit }) {
        const {
            observedElementRef: overlayRef,
        } = useIsInViewport({
            onEnterViewport: () => emit('bottomReached'),
        });

        return {
            overlayRef,
        };
    },
});
